var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E2E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.354 25.5C14.0591 26.1224 14.9853 26.5 15.9998 26.5C17.0142 26.5 17.9405 26.1224 18.6456 25.5M21.9998 12.5C21.9998 10.9087 21.3676 9.38258 20.2424 8.25736C19.1172 7.13214 17.5911 6.5 15.9998 6.5C14.4085 6.5 12.8824 7.13214 11.7571 8.25736C10.6319 9.38258 9.99977 10.9087 9.99977 12.5C9.99977 15.5902 9.22024 17.706 8.34944 19.1054C7.6149 20.2859 7.24763 20.8761 7.2611 21.0408C7.27601 21.2231 7.31463 21.2926 7.46155 21.4016C7.59423 21.5 8.19237 21.5 9.38863 21.5H22.6109C23.8072 21.5 24.4053 21.5 24.538 21.4016C24.6849 21.2926 24.7235 21.2231 24.7384 21.0408C24.7519 20.8761 24.3846 20.2859 23.6501 19.1054C22.7793 17.706 21.9998 15.5902 21.9998 12.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3013,
    cy: 7.8013,
    r: 3.8013,
    fill: "#2D3748",
    stroke: "#E2E8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ed074f6a8d4e2b208f8da6d57d8b3e8d.svg";
export { ForwardRef as ReactComponent };